module.exports = "/_next/static/chunks/fonts/AmsiProNormal-Black-62e15e7f11b8c7f2ae08c347c472e3fd.woff2";